/* * @Author: 刘枫 * @Date: 2020-10-27 11:19:44 * @Last Modified by: 李志远 *
@Last Modified time: 2022-01-We 10:45:20 */

<template>
  <div class="conInner">
    <section id="content_wrapper">
      <div class="data">
        <h2>完善基本资料</h2>
      </div>
      <div class="form_wrap white_box">
        <div class="box">
          <div class="top"></div>
          <div
            class="body"
            style="background: #fff"
          >
            <Form
              id="ivu-form"
              ref="userInfoDate"
              :model="userInfoDate"
              :rules="ruleValidate"
              :label-width="80"
            >
              <!--<FormItem label="用户名">
                {{userInfoDate.uname}}
              </FormItem>-->
              <FormItem label="上传头像">
                <div
                  class="demo-upload-list"
                  v-for="(item, index) in uploadList"
                  :key="index"
                >
                  <template v-if="item.status === 'finished'">
                    <img :src="item.url" />
                  </template>
                  <template v-else>
                    <Progress
                      v-if="item.showProgress"
                      :percent="item.percentage"
                      hide-info
                    ></Progress>
                  </template>
                </div>
                <Upload
                  ref="upload"
                  :show-upload-list="false"
                  :default-file-list="defaultList"
                  :on-success="handleSuccess"
                  :format="['jpg', 'jpeg', 'png']"
                  :max-size="1024"
                  :on-format-error="handleFormatError"
                  :on-exceeded-size="handleMaxSize"
                  :before-upload="handleBeforeUpload"
                  :data="uploadData"
                  :headers="{ 'Auth-Token': upHeaders }"
                  type="drag"
                  :action="UploadUrl()"
                  style="display: inline-block; width: 58px"
                >
                  <div style="width: 58px; height: 58px; line-height: 58px">
                    <Icon
                      type="camera"
                      size="20"
                    ></Icon>
                  </div>
                </Upload>
              </FormItem>
              <FormItem
                label="昵称"
                prop="nickname"
              >
                <Input
                  v-model="userInfoDate.nickname"
                  placeholder="请输入昵称."
                  clearable
                  style="width: 200px"
                ></Input>
              </FormItem>
              <FormItem
                label="登录密码"
                prop="oldPassword"
              >
                <Input
                  type="password"
                  v-model="userInfoDate.oldPassword"
                  placeholder="请输入登录密码."
                  clearable
                  style="width: 200px"
                ></Input>
              </FormItem>
              <FormItem
                label="支付密码"
                prop="payPassword"
              >
                <Input
                  type="password"
                  v-model="userInfoDate.payPassword"
                  placeholder="请输入密码."
                  clearable
                  style="width: 200px"
                ></Input>
              </FormItem>
              <FormItem
                label="确认密码"
                prop="payPwdCheck"
              >
                <Input
                  type="password"
                  v-model="userInfoDate.payPwdCheck"
                  placeholder="请确认密码."
                  clearable
                  style="width: 200px"
                ></Input>
              </FormItem>
              <FormItem
                label="性别"
                prop="sex"
              >
                <RadioGroup v-model="userInfoDate.sex">
                  <Radio label="男"></Radio>
                  <Radio label="女"></Radio>
                </RadioGroup>
              </FormItem>
              <FormItem label="生日">
                <Row>
                  <DatePicker
                    :value="userInfoDate.birthday"
                    v-model="userInfoDate.birthday"
                    :transfer="true"
                    format="yyyy年MM月dd日"
                    type="date"
                    placeholder="请输入生日"
                  ></DatePicker>
                </Row>
              </FormItem>
              <!--<FormItem label="常住地">
                <Cascader  :load-data="loadData" v-model="value2" :data="placeData" :transfer="true" trigger="click" style="width: 200px"></Cascader>
              </FormItem>-->
              <FormItem
                label="常住地"
                prop="address"
              >
                <Input
                  v-model="userInfoDate.address"
                  placeholder="请输入联系地址."
                  clearable
                ></Input>
              </FormItem>
              <FormItem label="所属市场：">
                <Select
                  disabled
                  v-model="userInfoDate.legionSn"
                >
                  <Option
                    v-for="item in armyGroupList"
                    :value="item.legionSn"
                    :key="item.legionSn"
                  >{{ item.legionName }}
                  </Option>
                </Select>
              </FormItem>
              <FormItem>
                <Button
                  type="primary"
                  @click="handleSubmit('userInfoDate')"
                >保存</Button>
              </FormItem>
            </Form>
          </div>
          <div class="bottom"></div>
        </div>
      </div>
    </section>
    <Modal
      :styles="{top: '300px'}"
      v-model="legionmModal"
      title="请输入选择市场"
      :mask-closable="false"
      :closable="false"
    >
      <Select
        v-model="userInfoDate.legionSn"
        filterable
      >
        <Option
          v-for="item in armyGroupList"
          :value="item.legionSn"
          :key="item.legionSn"
        >{{ item.legionName }}</Option>
      </Select>
      <div slot="footer"><Button
          type="primary"
          @click="okLegionSn"
        >确定</Button></div>
    </Modal>
  </div>
</template>
<style>
.demo-upload-list {
  display: inline-block;
  width: 60px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  margin-right: 4px;
}
.demo-upload-list img {
  width: 100%;
  height: 100%;
}
.demo-upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
}
.demo-upload-list:hover .demo-upload-list-cover {
  display: block;
}
.demo-upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 2px;
}
#ivu-form {
  padding-left: 100px;
  height: 650px;
}
#ivu-form .ivu-form-item-content {
  width: 200px;
}
#ivu-form .ivu-form-item:last-child {
  margin-bottom: 0px !important;
}
</style>
<script>
import {
  getUserInfo,
  updateProfile,
  getArmyGroupDatas,
  updateLegionSn,
} from "api/user.js";
import { getSession, setSession, getNowFormatDate } from "utils/tool";
import { encryptDes } from "utils/des";
import { generatekey, encryptDesPost, decryptDes } from "utils/des-post";
export default {
  data() {
    const validateNickname = (rule, value, callback) => {
      this.userInfoDate.nickname = value.replace(/\s+/g, "");
      var n = 0,
        m = 0;
      if (this.userInfoDate.nickname) {
        for (var i in this.userInfoDate.nickname) {
          if (/[^\x00-\xff]/g.test(this.userInfoDate.nickname[i])) {
            n++;
          } else if (/^[\w\s]+$/g.test(this.userInfoDate.nickname[i])) {
            m++;
          }
        }
        if (n * 2 + m > 12) {
          callback("昵称不能超过12个字符");
        } else {
          callback();
        }
      } else {
        callback(new Error("昵称不能为空"));
      }
    };
    const validateAddress = (rule, value, callback) => {
      this.userInfoDate.address = value.replace(/\s+/g, "");
      var n = 0,
        m = 0;
      if (this.userInfoDate.address) {
        for (var i in this.userInfoDate.address) {
          if (/[^\x00-\xff]/g.test(this.userInfoDate.address[i])) {
            n++;
          } else if (/^[\w\s]+$/g.test(this.userInfoDate.address[i])) {
            m++;
          }
        }
        if (n * 2 + m > 40) {
          callback("联系地址不能超过40个字符");
        } else {
          callback();
        }
      }
    };
    const validatePayPwd = (rule, value, callback) => {
      if (!value || value === "") {
        callback(new Error("支付密码不能为空"));
      } else {
        var reg = /^.{6,}$/;
        if (!reg.test(value)) {
          return callback(new Error("最少6个字符"));
        } else {
          callback();
        }
      }
    };
    const validatePayPwdCheck = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再输入一次支付密码"));
      } else if (value !== this.userInfoDate.payPassword) {
        callback(new Error("两次输入支付密码不一致!"));
      } else {
        callback();
      }
    };

    return {
      legionmModal: false, // 军团选择模态框
      defaultList: [
        {
          name: "",
          url: "",
        },
      ],
      imgName: "",
      MEMBER_HOST: process.env.PROTOCOL + "://" + process.env.MEMBER_HOST,
      uploadData: { type: "USER_IMAGE" },
      visible: false,
      uploadList: [],
      userInfoDate: {
        nickname: "",
        mobile: "",
        address: "",
        oldPassword: "",
        payPassword: "",
        legionSn: "",
        legionName: "",
        sex: "",
        payPwdCheck: ""
      },
      placeData: [],
      getregionIdFalg: false,
      ruleValidate: {
        nickname: [
          { required: true, validator: validateNickname, trigger: "blur" },
        ],
        address: [
          { required: false, validator: validateAddress, trigger: "blur" },
        ],
        // zip: [
        //   { required: false,validator: validateZip, trigger: 'blur' }
        // ],
        oldPassword: [{ validator: validatePayPwd, trigger: "blur" }],
        payPwdCheck: [{ validator: validatePayPwdCheck, trigger: "blur" }],
        // mobile: [
        //   { required: false, validator:validateMobile,trigger: 'blur' }
        // ],
        // tel: [
        //   { required: false,validator: validateTel, trigger: 'blur' }
        // ],
      },
      upHeaders: "", //图片上传请求头
      armyGroupList: [], // 军团信息
    };
  },
  created() {
    this.getArmyGroupDatas();
    this.getUpHeaders();
  },
  mounted() {
    this.getUserInfoDate();
    this.uploadList = this.$refs.upload.fileList;
  },
  methods: {
    // 设置军团信息
    updateLegionSn() {
      let data = {
        legionSn: this.userInfoDate.legionSn,
      };
      updateLegionSn(data).then((res) => {
        if (res.resCode == 1) {
          this.getUserInfoDate();
        } else {
          this.userInfoDate.legionSn = "";
          layer.msg(res.resDesc, { icon: 2 });
        }
      });
    },
    okLegionSn() {
      this.legionmModal = false;
      this.updateLegionSn();
    },
    // 获取军团信息
    getArmyGroupDatas() {
      getArmyGroupDatas().then((res) => {
        this.armyGroupList = res.data;
      });
    },
    //设置图片上传请求头
    getUpHeaders() {
      let commonBody = {
        client: "PC",
        transeq: getNowFormatDate(),
        mac: "",
        product: "GDOMALL", // 产品类型（必传参数）
        accessSource: "PC", // 访问来源（必传参数）
        version: "1.0.0", //当前请求来源的版本号（必传参数）
        sid: getSession("sid"), // 结算返回的uid（登录状态必传参数）
      };
      this.upHeaders = encryptDes(JSON.stringify(commonBody));
    },
    UploadUrl: function () {
      let actionPath = this.MEMBER_HOST + "/api/member/upload/headLogo";
      return actionPath;
    },
    formatDate(time) {
      // return new Date(time).toLocaleDateString().replace(/\//g, "-");
      return new Date(time).getTime() / 1000;
    },
    //保存个人资料
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          let key = generatekey('member')
          console.log(key, 'key');
          let _params = {
            nickname: this.userInfoDate.nickname,
            sex: this.userInfoDate.sex == "男" ? 0 : 1,
            birthday: this.formatDate(this.userInfoDate.birthday),
            address: this.userInfoDate.address,
            payPassword: this.userInfoDate.payPassword,
            oldPassword: this.userInfoDate.oldPassword,
            face: getSession("face"),
            legionSn: this.userInfoDate.legionSn,
          };
          const encrypts = encryptDesPost(JSON.stringify(_params), key)
          updateProfile(encrypts, 2).then((json) => {
            if (json.resCode == "1") {
              this.$Message.success(json.resDesc);
              setSession("name", this.userInfoDate.nickname);
              this.$store.dispatch("initName").then(() => {
                this.$router.push({ path: "member" });
              });
            } else {
              this.$Message.warning(json.resDesc);
            }
          });
        }
      });
    },
    //时间戳格式转换
    getDate: function (num) {
      var newDate = new Date();
      newDate.setTime(num * 1000);
      return newDate.toLocaleDateString();
    },
    //上传成功
    handleSuccess(res, file) {
      this.$Message.success(res.resDesc);
      this.getUserInfoDate();
      this.uploadList = this.defaultList;
    },
    //上传失败
    handleFormatError(file) {
      this.$Notice.warning({
        title: "文件格式不正确",
        desc: "请选择jpg和png.",
      });
    },
    //上传文件大小限制
    handleMaxSize(file) {
      this.$Notice.warning({
        title: "文件大小超过限制",
        desc: "文件太大,不能超过 1M.",
      });
    },
    //上传文件数量限制
    handleBeforeUpload(file) {
      const check = this.uploadList.length < 2;
      if (!check) {
        this.$Notice.warning({
          title: "只能上传一张头像图片.",
        });
      }
      return check;
    },
    //获取个人资料
    getUserInfoDate: function () {
      getUserInfo().then((json) => {
        if (json.resCode == "1") {
          this.userInfoDate = json.data;
          this.userInfoDate.sex = json.data.sex == 0 ? "男" : "女";
          this.userInfoDate.birthday = this.getDate(json.data.birthday);
          this.userInfoDate.mobile = json.data.telephone;
          this.userInfoDate.legionSn = json.data.legionSn;
          if (!json.data.legionSn) {
            this.legionmModal = true;
            this.userInfoDate.legionSn = this.armyGroupList[0].legionSn || "QT";
          }
          this.defaultList[0].url = json.data.face;
          setSession("face", json.data.face);
          this.$store.dispatch("initFace");
          return Promise.resolve();
        } else {
          this.$Message.info(json.resDesc);
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// personalProfile.vue?5791d8c2